var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"border-custom filter-button",class:{
    active: _vm.active
  },staticStyle:{"padding":"0.125rem"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"border-custom lock w-full h-full flex flex-col justify-center border-interaction-light",staticStyle:{"padding-bottom":"0.0625rem","border-radius":"0.2rem"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }